import { VChip } from 'vuetify/lib/components/VChip';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VChip,{staticClass:"mr-1 mb-1",staticStyle:{"padding-left":"8px","padding-right":"8px","background":"rgba(25, 113, 194, 0.2)"},attrs:{"small":"","label":""}},[_c('b',{staticStyle:{"color":"rgb(165, 216, 255)","letter-spacing":"1.2px"}},[_vm._v(_vm._s(_vm.displayText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }